import React from 'react';
import { getDatalakeImageUrl } from '../Helpers/DateLakeStorage';

function NoAccess() {
    return (
        <div className='w-100 h-100 d-flex flex-column justify-content-center align-items-center text-center font-size-4'>
            <div>
                <img
                    height={"350px"}
                    src={getDatalakeImageUrl("NoAccess.png")} />
            </div>
            <div>
                Only organization owner and administrators can manage the subscription.
            </div>
            <div>
                Please contact them to change your subscription.
            </div>
        </div>
    )
}

export default NoAccess;